var createStaticBgHelper = function(){
	return {
		render: function(){}
	};
};

module.exports = {
	create: function(){
		return createStaticBgHelper();
	}
};




//////////////////
// WEBPACK FOOTER
// ./sources/core/ui/timeline/tasks_canvas_render.gpl.js
// module id = 38
// module chunks = 0